var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoOutline = function SvgInfoOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.6,
    d: "M3.30006 12C3.30006 6.94183 7.44189 2.8 12.5001 2.8C17.5582 2.8 21.7001 6.94183 21.7001 12C21.7001 17.0582 17.5582 21.2 12.5001 21.2C7.44189 21.2 3.30006 17.0582 3.30006 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.1 7.3C14.1 6.60667 13.4933 6 12.8 6C12.1066 6 11.5 6.60667 11.5 7.3C11.5 7.99333 12.02 8.6 12.8 8.6C13.58 8.6 14.1 7.99333 14.1 7.3ZM11.3333 17H14.6667C15.1667 17 15.5 16.7641 15.5 16.2922C15.5 15.8203 15.1667 15.5057 14.6667 15.5057H14C13.9167 15.5057 13.8333 15.427 13.8333 15.3484V11.5731C13.8333 10.7079 13.0833 10 12.1667 10H11.3333C10.8333 10 10.5 10.3146 10.5 10.7866C10.5 11.2585 10.8333 11.5731 11.3333 11.5731H12C12.0833 11.5731 12.1667 11.6517 12.1667 11.7304V15.2697C12.1667 15.3484 12.0833 15.427 12 15.427H11.3333C10.8333 15.427 10.5 15.7416 10.5 16.2135C10.5 16.6854 10.8333 17 11.3333 17Z",
    clipRule: "evenodd"
  })));
};
export default SvgInfoOutline;